import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { TipoIdentificacionEnumChoice, gridSizeMdLg4, newProveedoresSchema } from "@/shared";
import {
  useCreateProveedor,
  useUpdateProveedor,
  useFetchTypeRegimens,
  useFetchPorcentajeIvaBienes,
  useFetchPorcentajeIvaServicios,
  useFetchProvinces,
  useFetchCitiesEnabled,
  useFetchGetPais,
  useFetchSearchIdentification,
} from "@/shared/actions/erp";
import {
  CustomAutocomplete,
  CustomTextField,
  SingleTableBoxScene,
  SampleCheckbox,
} from "@/shared/components/ui";
import CustomCellphoneTextField from "@/shared/components/ui/CustomCellphoneTextField";

import {
  PROVEEDOR,
  TYPERegimens,
  PORCENTAJEIVABIENES,
  PORCENTAJEIVASERVICIOS,
  Province,
  City,
  Pais,
  TipoDocumentoNameEnum,
  IDataRuc,
  IDataEstablecimientos,
} from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { IdentificacionTextField } from '@/erp/compras/proveedores/shared/components/IdentificacionProveedorTextField';
import { Grid } from "@mui/material";

import { toast } from "react-toastify";
const returnUrlProveedores = "/compras/proveedores";

export interface SaveProveedorProps {
  titlePage: string;
  editProveedor?: PROVEEDOR;
}

type SaveFormData = {
  tipo_identificacion: string;
  identificacion: string;
  nombre_comercial: string;
  direccion: string;
  email: string;
  telefono_1: string;
  telefono_2: string;
  contacto: string;
  contacto_cargo: string;
  contacto_email_1: string;
  contacto_email_2: string;
  contacto_telefono_1: string;
  contacto_telefono_2: string;
  estado: boolean;
  tipo_regimen: string;
  pais: string;
  provincia: string;
  ciudad: string;
  razon_social?: string;
  porcentaje_ret_iva_bienes: string;
  porcentaje_ret_iva_servicios: string;
  ///
  tipo_contribuyente?: string
  estado_contribuyente_ruc?: string
  establecimientos?: {
    nombreFantasiaComercial: string
  }
};
const SaveProveedor: React.FC<SaveProveedorProps> = ({
  titlePage,
  editProveedor,
}) => {
  const navigate = useNavigate();

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newProveedoresSchema),
    mode: "onChange",
  });

  const {
    handleSubmit,
    reset,
    control,
    formState: { errors, isValid },
  } = form;
  ///* local state
  const [shrink, setShrink] = useState(false);


  ///* global state
  const setAlert = useUiStore((s) => s.setAlert);
  const setIsGlobalLoading = useUiStore(s => s.setIsGlobalLoading);

  ///* fetch data

  const { data: TypeRegimenPaging, isLoading: isLoadingTypeRegimen } =
    useFetchTypeRegimens({
      page_size: 600,
    },);

  console.log('dataRegimen', TypeRegimenPaging)
  const {
    data: PorcentajeIvaBienesPaging,
    isLoading: isLoadingPorcentajeIvaBienes,
  } = useFetchPorcentajeIvaBienes({
    page_size: 600,
  });
  const {
    data: PorcentajeIvaServiciosPaging,
    isLoading: isLoadingPorcentajeIvaServicios,
  } = useFetchPorcentajeIvaServicios({
    page_size: 600,
  });
  const { data: CountryPaging, isLoading: isLoadingCountry } =
    useFetchGetPais({ page_size: 600 });

  const { data: ProvincePaging, isLoading: isLoadingProvince } =
    useFetchProvinces({
      page_size: 600,
      pais: form.getValues().pais
    }, !!form.watch('pais'));

  const { data: CityPaging, isLoading: isLoadingCity } =
    useFetchCitiesEnabled({
      params: {
        page_size: 600,
        provincia: form.getValues().provincia
      },
      //enabled: true
      enabled: !!form.watch('provincia')

    });



  ///* mutations
  const createProveedor = useCreateProveedor({ navigate, returnUrl: returnUrlProveedores });
  const updateProveedor = useUpdateProveedor({ navigate, returnUrl: returnUrlProveedores });
  const watchedTipoIdentificacion = form.watch('tipo_identificacion');
  const consultaIdentificacion = useFetchSearchIdentification({
    customSuccessMessage: 'Datos de identificación encontrados.',
  });
  ///* handlers

  const onSave = () => {
    /*  console.log('data', form.getValues())
     return; */
    if (!isValid) return;

    ///* upd
    if (editProveedor?.id_proveedor) {
      return updateProveedor.mutate({
        id: editProveedor.id_proveedor,
        data: form.getValues() as any,
      });
    }

    ///* create
    return createProveedor.mutate(form.getValues() as any);
  };
  ///*fetch
  const onChangeTypeRegimen = (value: string) => {
 
    form.setValue("tipo_regimen", value);
  };
 

  const onChangePorcentajeRetIvaBienes = (value: string) => {
    form.setValue("porcentaje_ret_iva_bienes", value);
  };
  const onChangePorcentajeRetIvaServicios = (value: string) => {
    form.setValue("porcentaje_ret_iva_servicios", value);
  };
  /* const onChangeTypeCountry = (value: string) => {
    form.setValue("pais", value);
  }; */
  const onChangeCiudad = (value: string) => {
    form.setValue("ciudad", value);
  };
  /*  const onChangeProvince = (value: string) => {
     form.setValue("provincia", value);
   }; */


  const handleConsultaIdentificacion = async (value: string) => {
    setIsGlobalLoading(true);
    if (watchedTipoIdentificacion === TipoDocumentoNameEnum.CEDULA) {
      const res = await consultaIdentificacion.mutateAsync({
        identificacion: value,
      });
      setIsGlobalLoading(false);
      const { data } = res;
      if (!data) return;

      form.setValue('razon_social', data?.razon_social);

      return;
    }

    if (watchedTipoIdentificacion === TipoDocumentoNameEnum.RUC) {
      const res = await consultaIdentificacion.mutateAsync({
        identificacion: value,
      });
      setIsGlobalLoading(false);

      const data: IDataRuc = res?.data as unknown as IDataRuc;


      let establecimientos: IDataEstablecimientos[] = []

      if (typeof data.establecimientos === 'string' && data.establecimientos.length > 0) {

        const jsonString = data.establecimientos
          .replace(/'/g, '"')
          .replace(/\bNone\b/g, 'null');

        try {
          establecimientos = JSON.parse(jsonString);
        } catch (e) {
          console.error('Error parseando establecimientos:', e);
          establecimientos = [];
        }
      }
      const nombreFantasia =
        establecimientos.length > 0
          ? establecimientos[0].nombreFantasiaComercial || ''
          : '';
      const nombreTiporRegimen = TypeRegimenPaging?.data.data.find(item => item.nombre === data.regimen)

      if (nombreTiporRegimen) {
        form.setValue('tipo_regimen', nombreTiporRegimen.codigo)
      }else{
        toast.info(`No existe el "tipo regimen" con el nombre ${data?.regimen},le sugerimos que debes crear en el "modulo tipos de regímenes", para continuar con el proceso.` )
      }
      form.setValue('razon_social', data?.razonSocial);
      /* form.setValue('tipo_regimen', data?.regimen || ''); */
      form.setValue('tipo_contribuyente', data?.tipo_contribuyente || '')
      form.setValue('nombre_comercial', nombreFantasia && nombreFantasia.trim() !== '' ? nombreFantasia : data.razonSocial)
      form.setValue('estado_contribuyente_ruc', data.estado_contribuyente_ruc || '')

      return;
    }

    setIsGlobalLoading(false);
  };

  ///* effects
  useEffect(() => {
    if (editProveedor?.id_proveedor) {
      setShrink(true);
      reset({
        ...editProveedor,
        estado: !!editProveedor.estado ? ("1" as any) : ("0" as any),
      });
    }
  }, [editProveedor, form]);

  const tipoEmpleadosOptions = Object.entries(TipoIdentificacionEnumChoice).map(
    ([key, value]) => ({ label: key, value })
  );


  
  
  return (
    <>
      <SingleTableBoxScene
        title={titlePage}
        enableBackBtn={true}
        backPageUrl="/compras/proveedores"
        visibleReport={false}
        enableCreateOrEditBtn={true}
        textCreateOrEditBtn="Guardar"
        fnCreateOrEdit={handleSubmit(onSave, () => {
          setAlert(true, "Faltan campos por llenar", "error");
        })}
      >
        <Grid container spacing={3}>
          <CustomAutocomplete
            label="Tipo de Identificación"
            name="tipo_identificacion"
            control={form.control}
            defaultValue={form.getValues().tipo_identificacion || ''}
            error={errors.tipo_identificacion}
            helperText={errors.tipo_identificacion?.message}
            options={tipoEmpleadosOptions}
            isLoadingData={false}
            valueKey="value"
            optionLabelForEdit={form.getValues().tipo_identificacion}
            size={gridSizeMdLg4}
            onChangeValue={(e)=>{
               console.log('e', e)
               if(e){
                form.reset({
                  ...form.getValues(),
                  identificacion:(''),
                  razon_social:(''),
                  nombre_comercial:(''),
                  tipo_contribuyente:(''),
                  estado_contribuyente_ruc:(''),
                  tipo_regimen:('')
                })
               }
               
            }}
          />

          <IdentificacionTextField
            control={form.control}
            name="identificacion"
            label="Identificación"
            defaultValue={form.getValues().identificacion || ''}
            error={errors.identificacion}
            helperText={errors.identificacion?.message}
            //
            disabled={!watchedTipoIdentificacion}
            selectedDocumentType={watchedTipoIdentificacion}
            onFetchCedulaRucInfo={handleConsultaIdentificacion}
            size={gridSizeMdLg4}
          />
          <CustomTextField
            name="razon_social"
            label="Razón Social"
            control={form.control}
            defaultValue={form.getValues().razon_social || ""}
            error={errors.razon_social}
            helperText={errors.razon_social?.message}
            shrink={shrink}
            size={gridSizeMdLg4}
          />
          <CustomTextField
            name="nombre_comercial"
            label="Nombre Comercial"
            control={form.control}
            defaultValue={form.getValues().nombre_comercial || ""}
            error={errors.nombre_comercial}
            helperText={errors.nombre_comercial?.message}
            shrink={shrink}
            size={gridSizeMdLg4}
          />

          {form.getValues().tipo_identificacion === TipoDocumentoNameEnum.RUC && (
            <>
              <CustomTextField
                name="tipo_contribuyente"
                label="Tipo Contribuyente"
                control={form.control}
                defaultValue={form.getValues().tipo_contribuyente || ""}
                error={errors.tipo_contribuyente}
                helperText={errors.tipo_contribuyente?.message}
                shrink={shrink}
                size={gridSizeMdLg4}
              />

              <CustomTextField
                name="estado_contribuyente_ruc"
                label="Estado Contribuyente"
                control={form.control}
                defaultValue={form.getValues().estado_contribuyente_ruc || ""}
                error={errors.estado_contribuyente_ruc}
                helperText={errors.estado_contribuyente_ruc?.message}
                shrink={shrink}
                size={gridSizeMdLg4}
              />
            </>
          )}


          <CustomTextField
            name="direccion"
            label="Dirección"
            control={form.control}
            defaultValue={form.getValues().direccion || ""}
            error={errors.direccion}
            helperText={errors.direccion?.message}
            shrink={shrink}
            size={gridSizeMdLg4}

          />
          <CustomTextField
            label="Correo Electrónico"
            name="email"
            control={control}
            error={errors.email}
            helperText={errors.email?.message}
            shrink={shrink}
            type="email"
            size={gridSizeMdLg4}
          />
          <CustomCellphoneTextField
            name="telefono_1"
            label="Teléfono 1"
            control={form.control}
            defaultValue={form.getValues().telefono_1 || ""}
            error={errors.telefono_1}
            helperText={errors.telefono_1?.message}
            shrink={shrink}
            size={gridSizeMdLg4}
          />

          <CustomCellphoneTextField
            name="telefono_2"
            label="Teléfono 2"
            control={form.control}
            defaultValue={form.getValues().telefono_2 || ""}
            error={errors.telefono_2}
            helperText={errors.telefono_2?.message}
            shrink={shrink}
            size={gridSizeMdLg4}
          />
          <CustomTextField
            label="Nombre del contacto"
            name="contacto"
            control={form.control}
            error={errors.contacto}
            helperText={errors.contacto?.message}
            shrink={shrink}
            type="contacto"
            size={gridSizeMdLg4}
          />

          <CustomTextField
            name="contacto_cargo"
            label="cargo contacto"
            control={form.control}
            defaultValue={form.getValues().contacto_cargo || ""}
            error={errors.contacto_cargo}
            helperText={errors.contacto_cargo?.message}
            shrink={shrink}
            size={gridSizeMdLg4}
          />
          <CustomTextField
            label="Correo Electrónico 1"
            name="contacto_email_1"
            control={control}
            error={errors.contacto_email_1}
            helperText={errors.contacto_email_1?.message}
            shrink={shrink}
            type="email"
            size={gridSizeMdLg4}
          />
          <CustomTextField
            label="Correo Electrónico 2"
            name="contacto_email_2"
            control={control}
            error={errors.contacto_email_2}
            helperText={errors.contacto_email_2?.message}
            shrink={shrink}
            type="email"
            size={gridSizeMdLg4}
          />
          <CustomCellphoneTextField
            name="contacto_telefono_1"
            label="Contacto de teléfono 1"
            control={form.control}
            defaultValue={form.getValues().contacto_telefono_1 || ""}
            error={errors.contacto_telefono_1}
            helperText={errors.contacto_telefono_1?.message}
            shrink={shrink}
            size={gridSizeMdLg4}
          />
          <CustomCellphoneTextField
            name="contacto_telefono_2"
            label="Contacto de teléfono 2"
            control={form.control}
            defaultValue={form.getValues().contacto_telefono_2 || ""}
            error={errors.contacto_telefono_2}
            helperText={errors.contacto_telefono_2?.message}
            shrink={shrink}
            size={gridSizeMdLg4}
          />
          

          <CustomAutocomplete<TYPERegimens>
            label="Tipo Regimen"
            name="tipo_regimen"
            //// options
            options={TypeRegimenPaging?.data.data || []}
            // label & search by name
            valueKey="nombre"
            actualValueKey="codigo"
            //
            defaultValue={form.getValues().tipo_regimen || ""}
            optionLabelForEdit={form.getValues().tipo_regimen || ""}
            isLoadingData={isLoadingTypeRegimen}
            //// validation
            control={control}
            error={errors.tipo_regimen}
            helperText={errors.tipo_regimen?.message}
            onChangeValue={onChangeTypeRegimen}

            size={gridSizeMdLg4}
          />
          <CustomAutocomplete<Pais>
            label="Pais"
            name="pais"
            actualValueKey="codigo"
            //// options
            options={CountryPaging?.data.data || []}
            // label & search by name
            valueKey="nombre"
            //
            defaultValue={form.getValues().pais || ""}
            optionLabelForEdit={form.getValues().pais || ""}
            isLoadingData={isLoadingCountry}
            //// validation
            control={control}
            error={errors.pais}
            helperText={errors.pais?.message}
            onChangeValue={(e) => {
              reset({ ...form.getValues(), pais: e, provincia: '', ciudad: '' })
            }/* onChangeTypeCountry */}
            size={gridSizeMdLg4}
          />

          {form.getValues().pais && (
            <CustomAutocomplete<Province>
              label="Provincia"
              name="provincia"
              //// options
              options={ProvincePaging?.data.data || []}
              // label & search by name
              valueKey="nombre"

              actualValueKey="codigo"
              //
              defaultValue={form.getValues().provincia || ""}
              optionLabelForEdit={form.getValues().provincia || ""}
              isLoadingData={isLoadingProvince}
              //// validation
              control={control}
              error={errors.provincia}
              helperText={errors.provincia?.message}
              onChangeValue={(e) => {
                reset({
                  ...form.getValues(), provincia: e, ciudad: ''
                })
              }/* onChangeProvince */}
              size={gridSizeMdLg4}
            />

          )}
          {form.getValues().provincia && (
            <CustomAutocomplete<City>
              label="Ciudad"
              name="ciudad"
              //// options
              options={CityPaging?.data.data || []}
              // label & search by name
              valueKey="nombre"
              actualValueKey="codigo"
              //
              defaultValue={form.getValues().ciudad || ""}
              optionLabelForEdit={form.getValues().ciudad || ""}
              isLoadingData={isLoadingCity}
              //// validation
              control={control}
              error={errors.ciudad}
              helperText={errors.ciudad?.message}
              onChangeValue={onChangeCiudad}
              size={gridSizeMdLg4}
            />
          )}

          <CustomAutocomplete<PORCENTAJEIVABIENES>
            label="Porcentaje retencion iva bienes"
            name="porcentaje_ret_iva_bienes"
            // options
            options={PorcentajeIvaBienesPaging?.data.data || []}
            valueKey="porcentaje" // name is the fk
            actualValueKey="codigo"
            defaultValue={form.getValues().porcentaje_ret_iva_bienes || ""}
            isLoadingData={isLoadingPorcentajeIvaBienes}
            control={control}
            error={errors.porcentaje_ret_iva_bienes}
            helperText={errors.porcentaje_ret_iva_bienes?.message}
            onChangeValue={onChangePorcentajeRetIvaBienes}
            optionLabelForEdit={
              PorcentajeIvaBienesPaging?.data.data
                .find(
                  (z) =>
                    z.id_porcentaje_ret_iva_bienes ===
                    form.getValues().porcentaje_ret_iva_bienes
                )
                ?.id_porcentaje_ret_iva_bienes?.toString() || ""
            }
            size={gridSizeMdLg4}
          />

          <CustomAutocomplete<PORCENTAJEIVASERVICIOS>
            label="Porcentaje retencion iva servicios"
            name="porcentaje_ret_iva_servicios"
            // options
            options={PorcentajeIvaServiciosPaging?.data.data || []}
            valueKey="porcentaje" // name is the fk
            actualValueKey="codigo"
            defaultValue={form.getValues().porcentaje_ret_iva_servicios || ""}
            isLoadingData={isLoadingPorcentajeIvaServicios}
            control={control}
            error={errors.porcentaje_ret_iva_servicios}
            helperText={errors.porcentaje_ret_iva_servicios?.message}
            onChangeValue={onChangePorcentajeRetIvaServicios}
            optionLabelForEdit={
              PorcentajeIvaServiciosPaging?.data.data
                .find(
                  (z) =>
                    z.id_porcentaje_ret_iva_servicios ===
                    form.getValues().porcentaje_ret_iva_servicios
                )
                ?.id_porcentaje_ret_iva_servicios?.toString() || ""
            }
            size={gridSizeMdLg4}
          />
          <SampleCheckbox
            label="Estado"
            name="estado"
            control={form.control}
            defaultValue={!!form.getValues().estado}
            isState
            size={gridSizeMdLg4}
          />
        </Grid>
      </SingleTableBoxScene>
    </>
  );
};
export default SaveProveedor;
